import React from "react"
import { Redirect }  from "react-router-dom"
import axios from "axios";
import { login as API_URL, host as ROOT_DIR } from "./config/api";
import {
    Form, Icon, Input, Button, Checkbox,
  } from 'antd';

const postUrlLogin = API_URL;

class Login extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            name                : "",
            email               : "",
            password            : "",
            fireRedirect        : false,
            fireLoginError      : false,
            resetModal          : false,
            request_send        : ""
        };
        this.getValidationState  = this.getValidationState.bind(this);
        this.getValidateSubmit   = this.getValidateSubmit.bind(this);
        this.handleLoginSubmit   = this.handleLoginSubmit.bind(this);
        this.handleInputChange   = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;
        this.setState({
            [name]: value,
            fireLoginError : false
        });
    }

    handleForgotCliced= (e) => {
        e.preventDefault();
        this.props.setForgot(true);
    }

    getValidationState(data){
        if ( data === "email" ){
            var $email = this.state[data];
            if ( $email.length && /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test($email) ){
                return "success"
            } else {
                return "error"
            }
        } else if ( data === "password" ){
            if ( this.state[data].length ){
                return "success"
            } else {
                return "error"
            }
        } else {
            return "success"
        }
    }
    componentWillMount(){
        var $self = this;
        let host = window.location.host;
        let parts = host.split(".");
        let subdomain = "";
        if (parts.length >= 3) {
            subdomain = parts[0];
        }else{
            subdomain = 'valentin';
        }
        this.props.app.setState({
            subdomain : subdomain
        })
    }
    getValidateSubmit(data){
        var $self = this;
        var $s = true;
        Object.keys(data).map(function(key) {
            if ( $self.getValidationState(key) !== "success" ){
                $s = false
            }
            return $s
        });
        return $s
    }
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {

        if (!err) {
            var $self = this;
            let host = window.location.host;
            let parts = host.split(".");
            let subdomain = "";
            if (parts.length >= 3) {
                subdomain = parts[0];
            }else{
                subdomain = 'valentin';
            }

            const data = {
                email     : values.email,
                password  : values.password,
                subdomain : subdomain
            };
            $self.setState({
                request_send : " hide",
                fireLoginError : false
            })
            let qs = require("qs"), self = this;

            axios.post(postUrlLogin, qs.stringify(data))
                .then(function (response) {
                    if ( response.data["status"] === "login" ){
                        const years = Object.keys(response.data["years_collection"]).map(function(index){
                            return response.data["years_collection"][index]['year']
                        })

                        const pickup_week = Object.keys(response.data["pickup_week"]).map(function(index){
                            return response.data["pickup_week"][index]
                        })
                        localStorage.setItem("api_token", response.data["api_token"]);
                        localStorage.setItem("name", response.data["name"]);
                        localStorage.setItem("email", response.data["email"]);
                        localStorage.setItem("past_year", response.data["past_year"]);
                        localStorage.setItem("current_year", response.data["current_year"]);
                        localStorage.setItem("years_collection", years);
                        localStorage.setItem("user_roles",  response.data["user_roles"]);
                        localStorage.setItem("max_book_year_pickup",  response.data["max_book_year_pickup"]);
                        localStorage.setItem("pickup_week",  pickup_week);

                        
                        $self.props.setSession(true, response.data["filter_column_custom"], response.data["table_stays"])
                        window.location.reload();
                    } else if ( response.data["status"] === "error" ){
                        $self.setState({ fireLoginError : true });
                    }
                    $self.setState({ request_send: "" });
                })
                .catch(function (error) {
                    console.log(error);
                })
            }
        });
    }
    handleLoginSubmit(event) {
        event.preventDefault();
    }

  render(){
    const { getFieldDecorator } = this.props.form;
    let self = this;
    let host = window.location.host;
    let parts = host.split(".");
    let subdomain = "";
    if (parts.length >= 3) {
        subdomain = parts[0];
    }else{
        subdomain = 'valentin';
    }
    //sub is 'subdomain', 'domain', type is 'com'
    return(
        <Form onSubmit={this.handleSubmit} className="container login">
        <h2 className="text-center">
            <img
                style={{
                    width : 200,
                    marginTop : '30px',
                    marginRight : 'auto',
                    marginLeft : 'auto'
                }}
                src={ROOT_DIR + "uploads/" + subdomain + "/logo_old.svg"} />
        </h2>
        <div className="card card-container">
            <div className="form-title">Login</div>
            <p className="input_title">Email</p>
            <Form.Item>
            {getFieldDecorator('email', {
                rules: [{
                    type: 'email', message: 'The input is not valid E-mail!',
                  }, {
                    required: true, message: 'Please input your E-mail!',
                  }],
            })(
                <Input prefix={<Icon type="mail" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" placeholder="user@email.com" />
            )}
            </Form.Item>
            <p className="input_title">Password</p>
            <Form.Item>
            {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Please input your Password!' }],
            })(
                <Input prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} size="large" type="password" placeholder="Secret Password" />
            )}
            </Form.Item>
            <Button style={{width : '100%', height : '40px'}} type="primary" htmlType="submit" className={"btn btn-lg btn-primary " + this.state.request_send }>
                Sign in
            </Button>

            <span className={"error-login " + (this.state.fireLoginError === true ? "" : "hide")}>
                The username or password are not valid
            </span>

            {/*<div className="forgot">
                <a href="#" onClick={this.handleForgotCliced}>Forgot your password?</a>
            </div>*/ }
        </div>
      </Form>
       /* <div className="container login">
            <br /><br />
            <h2 className="login_title text-center"></h2>
            <div className="card card-container">
                <div className="form-title">Login</div>
                <form onSubmit={this.handleLoginSubmit} className="form-signin">
                    <span id="reauth-email" className="reauth-email"></span>
                    <p className="input_title">Email</p>
                    <input type="email" id="inputEmail" name="email" className="login_box" value={this.state.emai} placeholder="user@email.com" onChange={this.handleInputChange} required autoFocus />
                    <p className="input_title">Password</p>
                    <input type="password" id="inputPassword" name="password" className="login_box" value={this.state.password} onChange={this.handleInputChange} placeholder="******" required />
                    <button className={"btn btn-lg btn-primary " + this.state.request_send } type="submit">LOGIN</button>
                    <span className={"error-login " + (this.state.fireLoginError === true ? "" : "hide")}>
                    The username or password are not valid
                    </span>
                    <div className="forgot">
                       <a href="#" onClick={this.handleForgotCliced}>Forgot your password?</a>
                    </div>
                </form>
            </div>
          </div> */
    )
  }
};

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(Login);

export default WrappedNormalLoginForm



// WEBPACK FOOTER //
// ./src/Frontend/Login.js